import { Typography, Box } from "@mui/material" 
import FormDescription from '../../../inputFormComponents/FormDescription'

const DescriptionUserCompany = () => {
  return (
    <FormDescription 
      paragraphs={[
        <Box key={1}>
          <Typography variant="body1">Firma:</Typography>
          <Typography variant="body2">Deine Firmendaten werden automatisch in das Rechnungsformular übernommen.</Typography>
        </Box>,
        <Box key={2}>
          <Typography variant="body1">Kleinunternehmer:</Typography>
          <Typography variant="body2">Falls du Kleinunternehmer bist, wird der Steuersatz automatisch auf 0% geschlüsselt. Gleichzeitig erhalten deine Rechnungsvorlagen die entsprechenden Hinweistexte.</Typography>
        </Box>,
        <Box key={3}>
          <Typography variant="body1">UStID:</Typography>
          <Typography variant="body2">Du musst in deiner Rechnung entweder deine Rechnungsnummer oder deine UStID angeben. Durch Aktivierung des Ausblendereglers wird anstelle deiner UStID deine Steuernummer in der Rechnung angezeigt.</Typography>
        </Box>,
    ]}
    />
  )
}

export default DescriptionUserCompany